import styled from 'styled-components';

import {Skeleton} from '~/shared/components/Loaders';
import {media} from '~/shared/theme/media';

const SkeletonButton = styled(Skeleton)`
  width: calc(100% - 32px);
  height: 48px;
  margin-right: auto;
  margin-left: auto;
  border-radius: 100px;
  margin-bottom: 8px;
  ${media.minLargeTablet`
    width: 100%;
    margin-right: inherit;
    margin-left: inherit;
  `}
`;

export default SkeletonButton;
